import btnStyle from '@/components/Shares/Button.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Card, Group, Image, Modal, NumberFormatter, Stack, Text, rem } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import type React from 'react';
import { useCallback, useState } from 'react';
import type { BuyCryptoModalType } from '.';
import classes from './DepositBuyCrypto.module.css';
import { PaymentItem } from './PaymentItem';
import { ServicesProviderDropdown } from './ServicesProviderDropdown';
import { type PaymentMethodType, payments } from './data';
export type BuyCryptoModalProps = {
  stack: BuyCryptoModalType;
};
export const BuyCryptoModal: React.FC<BuyCryptoModalProps> = ({
  stack
}) => {
  const {
    i18n
  } = useLingui();
  const [selected, setSelected] = useState<PaymentMethodType | null>(payments[0]);
  const handleOpen = useCallback(() => {
    stack.open('processing');
    stack.close('buy-crypto');
    setTimeout(() => {
      stack.open('success');
      stack.close('processing');
    }, 4000);
  }, [stack]);
  return <Modal.Root {...stack.register('buy-crypto')} centered classNames={classes}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header px={20} pt={32} pb={24}>
          <Modal.Title className={gunterzBold.className}>
            {i18n._('Buy crypto')}
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body px={20} pb={32}>
          <Stack>
            <Card radius={5} bg="var(--bg-400)">
              <Stack align="center" gap={5}>
                <Image src="/assets/tokens/bitcoin.svg" alt="bitcoin" w={90} h={88} />
                <Text fz="lg" lh={rem(18)} className={gunterzBold.className} c="var(--text-white)">
                  <NumberFormatter value={0.000562} thousandSeparator="," decimalScale={9} decimalSeparator="." suffix=" BTC" />
                </Text>
                <Text fz="sm" tt="uppercase" c="var(--text-prime)">
                  <NumberFormatter value={7000} thousandSeparator="," decimalScale={9} decimalSeparator="." prefix="$" suffix=" MXH" />
                </Text>
              </Stack>
            </Card>

            <Stack gap={10}>
              <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700}>
                {i18n._('Service provider')}
              </Text>
              <ServicesProviderDropdown />
            </Stack>

            <Stack gap={10}>
              <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700}>
                {i18n._('Choose payment method')}
              </Text>
              {payments.map(item => <PaymentItem key={item.paymentName} value={item.paymentName} checked={selected?.paymentName === item.paymentName} handleClick={() => setSelected(item)} {...item} />)}
            </Stack>

            <Group justify={payments.length <= 0 ? 'start' : 'end'}>
              <Button variant="transparent" px={0} fz="xs" c="var(--text-blue)" leftSection={<IconPlus size={22} />} onClick={() => stack.open('add-payment')}>
                {i18n._('ADD NEW CARD')}
              </Button>
            </Group>
          </Stack>
          <Group mt={24} justify="flex-end">
            <Button disabled={payments.length <= 0} fz={13} h={46} onClick={handleOpen} classNames={{
            root: payments.length <= 0 ? btnStyle.btnDisable : btnStyle.root
          }}>
              {i18n._('confirm payment')}
            </Button>
          </Group>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>;
};